<template>
	<div>
	  <SubTopNav :title="title" :image="image" />
	  <div class="page content">
		<div v-html="content"></div>
		<div></div>
		<div class="filter-capabilities" v-show="!currentContent">
			<b-button-group>
		      <b-button :variant="(showItems == 'ke') ? 'success' : ''"  @click="showItems = 'ke'">Key Industries</b-button>
		      <b-button :variant="(showItems == 'practice_area') ? 'success' : ''" @click="showItems = 'practice_area'">Practice Areas</b-button>
		      <b-button :variant="(showItems == 'all') ? 'success' : ''" @click="showItems = 'all'">All</b-button>
		    </b-button-group>
	    </div>
	    <!-- {{ currentContent }} -->
		<div :class="[(currentContent && currentContent.nid) ? 'no-grid' : 'person-grid', 'animated', 'fadeIn']">
			
			<div v-for="(item, index) in pageItems.slice().reverse()" :key="index" class="person" @click="loadContent(item)" v-show="(item.type[0].target_id == showItems) ||  showItems == 'all'">{{ item.title[0].value }} &raquo;</div>
		</div> 	
		<transition  mode="out-in" appear enter-active-class="animated zoomIn" leave-active-class="animated zoomOut">
			<div v-if="currentContent" class="current-person">
				<div>
					<div class="close-icon" @click="closeItem()"><i class="fas fa-times fa-2x"></i></div>
					<strong>{{ currentContent.title[0].value }}</strong>
					<div class="profile-pic" v-if="currentContent.field_profile_picture && currentContent.field_profile_picture.length > 0"><img :src="currentContent.field_profile_picture[0].url"></div>
					<div v-html="currentContent.body[0].value"></div>
				</div>
			</div>	
		</transition>
	  </div>
	 	
	
  </div>
</template>
<script>
// @ is an alias to /src
	import SubTopNav from "@/components/SubTopNav.vue";
	import { RepositoryFactory } from "@/repositories/RepositoryFactory"
  const ContentRepository = RepositoryFactory.get("content");

	export default {
	  name: "keyindustries",
	  components: {
	    SubTopNav
	  },
	  data: function(){
	  	return {
	  		content: null,
	  		image: null,
	  		currentContent:null,
	  		pageItems: [],
	  		showItems:'all',
	  		title:null
	  	}
	  },
	  methods: {
	  	async getPageOverview(){
	  		var type = "page"
	        var id = "23"
	        const { data } = await ContentRepository.get(type, id)

	        if (data.length > 0){
	        	if (data[0].body.length > 0){
	        		this.content = data[0].body[0].value
        		}

        		this.title = data[0].title[0].value
          
	          if (data[0].field_page_header_image.length > 0){
	          	this.image = data[0].field_page_header_image[0].url
	          }
          
        	}
	  	},	
	  	async getContent(){
	  		var type = "ke+practice_area"
	        var id = "all"
	        const { data } = await ContentRepository.get(type, id)
        

	        if (data.length > 0){

	          data.sort(function (a, b) {
	          	var nameA = a.title[0].value.toUpperCase(); // ignore upper and lowercase
					var nameB = b.title[0].value.toUpperCase();
	          	if (nameA < nameB) {
				    return 1;
				  }
				  if (nameA > nameB) {
				    return -1;
				  }
				  return 0;
	          })	

	          this.pageItems = data

	          var alias = this.$route.hash

	          if (alias){
	          	alias = alias.replace('#', '/')
	          	var itemArray = this.pageItems.filter(item => {
	          	 	return (alias == item.path[0].alias)
	          	})

	          	if (itemArray.length > 0){
	          		var loadItem = itemArray[0]
	          		this.loadContent(loadItem)
	          	}
	          }
	          
	        }
  		},
  		closeItem(){
  			this.currentContent = null

  			var path = this.$route.path
  			history.pushState(
			    {},
			    null,
			    path
			)
  		},
  		loadContent(item){
  			var alias = item.path[0].alias
  			alias = alias.replace('/', '#')

  			history.pushState(
			    {},
			    null,
			    this.$route.path + alias
			)
  			this.currentContent = item
  			window.scrollTo(0,0);

  		}
	  },
	  mounted(){
	  	this.getPageOverview()
	  	this.getContent()
	  	
	  }
	};
</script>
<style scoped>
	.page{
		text-align:left;
		margin-left:5%;
	}

	.filter-capabilities{
		text-align:center;
		margin-bottom:20px;
		position:relative;
		z-index:0;
	}

	.profile-pic{
		float:left;
		margin-right:25px;
		margin-bottom:25px;
	}

	.left-column{
		margin-bottom:25px;
	}

	.person{
		/*width:150px;
		height:150px;*/
		padding:30px;
		text-transform:uppercase;
		font-weight:bold;
		xcolor:#FFF;
		xbackground:#999;
		border-right:1px solid #999;
		border-bottom:1px solid #999;
		font-size:150%;
		min-height:125px;
		cursor:pointer;
		/*display:inline-block;*/
	}

	.btn-group{
		xborder:1px solid red;
	}

	.btn-group .btn, .btn-group .btn:hover, .btn-group .btn.active{
		border-radius:0;
		background:transparent;
		text-transform:uppercase;
		margin-right:3px;
		color:#333;
		border-top:0px solid #FFF;
		border-left:0px solid #FFF;
		border-right:0px solid #FFF;
		border-bottom:3px solid #333;
	}


	.btn-group .btn.btn-success{
		border-color:green;
		color:green;
	}

	.current-person{
		background:rgba(255, 255, 255, 0.95);
		/*position:relative;
		top:0;
		margin-left:300px;*/
		margin-left:220px;
		margin-top:-50px;
		margin-right:-4%;
		display:inline-block;
		min-height:100vh;
		padding:50px;
		text-align:left;
		z-index:0;
	}

	.close-icon{
		float:right;
		cursor:pointer;
		margin-right:-25px;
		margin-top:-25px;
	}

	.person:hover{
		background:blue;
		color:#FFF;
	}

	.position{
		font-family:"Tahoma";
		font-size:60%;
		font-weight:normal;
	}

	.person-grid{
		display:grid;
		grid-template-columns: 1fr 1fr;
		grid-gap:25px;
		xposition:relative;
		z-index:-0;
	}

	.no-grid{
		font-size:70%;
		width:220px;
		display:inline-block;
		position:absolute;
	}

	.no-grid .person{
		padding:0;
		width:200px;
		min-height:auto;
		padding:15px 5px;
		text-transform: none;
		border-right:0px solid #FFF;
	}

	.page-image img{
		max-width:100%;
	}


	.page-image{
		background-size:cover;
		margin-bottom:25px;
	}

	.square{
		width:25%;
		overflow:hidden;
	}

	.square.blue{
		float:left;
		background:rgba(0,102,255,0.8);
	}

	.square.green{
		background:rgba(0,153,51,0.8);
		/*float:left;*/
	}

	.square.yellow{
		background:rgba(255,255,0,0.8);
		float:right;
	}

	.square.grey{
		background:rgba(204,204,204,0.5);
		/*clear:both;*/
		/*float:right;*/
	}

	.square:after {
	  content: "";
	  display: block;
	  padding-bottom: 100%;
	  /*background:transparent;*/
	}

	@media (max-width:768px){
		.current-person{
			background:rgba(255, 255, 255, 0.95);
			position:absolute;
			/*width:100%;
			height:100vh;*/
			top:350px;
			left:0px;
			xbottom:0 !important;
			margin-left:0px;
			margin-right:0px;
			xbottom: 0px;
			padding-bottom:100px;
			right:0px;
			text-align:left;
			z-index:100;
			xmin-height:100vh;
		}
		.no-grid{
			display:none;
			xborder:1px solid red;
			/*font-size:100%;
			position:static;
			display:grid;
			grid-template-columns: 1fr;
			grid-gap:25px;
			position:relative;
			z-index:-0;*/
		}

		.person-grid{
			grid-template-columns: 1fr;
		}

		.no-grid .person{
			padding:30px;
			width:auto;
			text-transform:uppercase;
			border-right:1px solid #999;
			min-height:125px;
		}

	}
</style>
